import React from "react";
import PropTypes from "prop-types";

import { Grid, makeStyles, Container } from "@material-ui/core";
import GrowLazyGrid from "../GrowLazyGrid";

function TwoOverOne(props) {
  const classes = useStyles();

  const { matches, project, getTimeOut } = props;

  return (
    <div className={classes.projectContainer}>
      <GrowLazyGrid
        src={project?.ProjectAssets?.data[1]?.attributes}
        gridWidth={6}
        imgclass={classes.fullWidth}
        getTimeOut={getTimeOut()}
        style={{ gridArea: "a" }}
      />
      <GrowLazyGrid
        src={project?.ProjectAssets?.data[2]?.attributes}
        gridWidth={6}
        imgclass={classes.fullWidth}
        getTimeOut={getTimeOut()}
        style={{ gridArea: "b" }}
      />
      <GrowLazyGrid
        src={project?.ProjectAssets?.data[0]?.attributes}
        gridWidth={12}
        imgclass={classes.fullWidth}
        getTimeOut={getTimeOut()}
        style={{ gridArea: "c" }}
      />
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    overflow: "hidden",

    [theme.breakpoints.down("md")]: {
      marginBottom: 8,
    },
    [theme.breakpoints.up("sm")]: {
      marginTop: "64px",
    },
  },
  fullWidth: {
    width: "100%",
    height: "100%",
    // maxWidth: 1400,
    margin: "0 auto",

    [theme.breakpoints.up("md")]: {
      // margin: 0,
    },
    [theme.breakpoints.up("lg")]: {
      // margin: "4rem 4rem 1rem 4rem",
    },
  },
  projectContainer: {
    overflow: "hidden",
    display: "grid",
    gridTemplateAreas: `"a b" "c c"`,
    gap: ".8% .8%",
  },
}));

TwoOverOne.propTypes = { matches: PropTypes.bool, project: PropTypes.object };
TwoOverOne.defaultProps = {
  matches: false,
  project: {
    ProjectAssets: {},
    layout: "TwoOverOne",
    title: "Default Title",
  },
};
export default TwoOverOne;
